import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import axios from "axios";
import Loading from "../../components/loading/Loading";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import "./home.scss";

const Inquiry = () => {
  const [inquiries, setInquiries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedInquiry, setSelectedInquiry] = useState(null); // for popup
  const [open, setOpen] = useState(false); // dialog open state

  // ================= GET ALL INQUIRIES =================
  const fetchInquiries = async () => {
    try {
      setLoading(true);
      const response = await axios.get("/get-inquiries"); // your API route

      const mapped = response.data
        .map((item) => ({
          id: item._id,
          name: item.name,
          email: item.email,
          phone: item.phone,
          message: item.message,
          date: item.createdAt ? new Date(item.createdAt).toLocaleString() : "",
        }))
        .sort((a, b) => new Date(b.date) - new Date(a.date)); // latest first

      setInquiries(mapped);
    } catch (error) {
      console.error("Error fetching inquiries:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInquiries();
  }, []);

  // ================= DIALOG HANDLERS =================
  const handleOpenDialog = (inquiry) => {
    setSelectedInquiry(inquiry);
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
    setSelectedInquiry(null);
  };

  // ================= COLUMNS =================
  const columns = [
    { field: "name", headerName: "Name", width: 150 },
    { field: "email", headerName: "Email", width: 200 },
    { field: "phone", headerName: "Phone", width: 150 },
    {
      field: "message",
      headerName: "Message",
      width: 200,
      renderCell: (params) => (
        <span
          style={{ cursor: "pointer", color: "blue" }}
          onClick={() => handleOpenDialog(params.row)}
        >
          {params.value.length > 30
            ? params.value.substring(0, 30) + "..."
            : params.value}
        </span>
      ),
    },
    { field: "date", headerName: "Date", width: 200 },
  ];

  return (
    <div className="main_wrp">
      <div className="main_page_wrp">
        <div className="head_wrp">
          <h3>
            All <em>Inquiries</em>
          </h3>
        </div>

        <div className="main_body_wrp">
          {loading ? (
            <Loading />
          ) : (
            <DataGrid
              rows={inquiries}
              columns={columns}
              getRowId={(row) => row.id}
              pageSizeOptions={[5, 10]}
              initialState={{
                pagination: { paginationModel: { pageSize: 5, page: 0 } },
              }}
              disableRowSelectionOnClick
              slots={{ toolbar: GridToolbar }}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
            />
          )}
        </div>

        {/* ================= POPUP DIALOG ================= */}
        <Dialog open={open} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
          <DialogTitle>Inquiry Details</DialogTitle>
          <DialogContent dividers>
            {selectedInquiry && (
              <div style={{ lineHeight: "1.6" }}>
                <p>
                  <strong>Name:</strong> {selectedInquiry.name}
                </p>
                <p>
                  <strong>Email:</strong> {selectedInquiry.email}
                </p>
                <p>
                  <strong>Phone:</strong> {selectedInquiry.phone}
                </p>
                <p>
                  <strong>Message:</strong>
                </p>
                <p>{selectedInquiry.message}</p>
                <p>
                  <strong>Date:</strong> {selectedInquiry.date}
                </p>
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};

export default Inquiry;
